/**
 * Builds request params for fetching a quoted/replied-to message.
 * Prefer exact sourceId so MessageFinder can resolve quotes across
 * prior conversations of the same contact/inbox (Meta Cloud self-replies).
 *
 * @param {{ messageId?: number|string|null, sourceId?: string|null }} replyReference
 * @param {number|string} conversationId
 * @returns {{ conversationId: number|string, sourceId: string } | { conversationId: number|string, after: number, before: number } | null}
 */
export const buildReplyFetchParams = (replyReference, conversationId) => {
  if (!replyReference || conversationId == null || conversationId === '') {
    return null;
  }

  const { sourceId } = replyReference;
  if (sourceId) {
    return {
      conversationId,
      sourceId,
    };
  }

  const numericMessageId = Number(replyReference.messageId);
  if (!Number.isInteger(numericMessageId) || numericMessageId <= 0) {
    return null;
  }

  return {
    conversationId,
    after: numericMessageId,
    before: numericMessageId + 1,
  };
};
